
import React, { useState } from 'react';
import { Container, Col, Row, Image } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import AboutSideBar from './AboutSideBar';
import { Helmet } from 'react-helmet';


const teamData = [
    {
        category: 'Admin and Backend Support',
        members: [
            {
                id: '1',
                name: 'Deepa Choudhary',
                role: 'Admin and Backend Support',
                image: 'deepa-choudhary.jpeg',
                description: 'Deepa has completed her M.Com and is part of the Accounts Team at Muskaan. She is interested in reading new research and articles related to education and health, driving, photography, helping people, and social work. Since 2008, she has been working with different organisations on issues related to physical and mental health, women`s health, and education. Whenever she has free time, she likes to spend it with books and family.'
            },
            {
                id: '2',
                name: 'Laila Jagat',
                role: 'Admin and Backend Support',
                image: 'laila-jagat.jpeg',
                description: 'Laila has been working at Muskaan since 2018 as a cook. She did not work while her husband was alive, but after he passed away, she started working and raising her children by herself. She has made a home for herself here, her daughter is also studying in class 10 at Muskaan. She has a great relationship with the children here. '
            },
            {
                id: '3',
                name: 'Pooja Singh',
                role: 'Admin and Backend Support',
                image: 'pooja-singh.jpeg',
                description: 'Pooja belongs to the Bhil tribe and is interested in making Bhil paintings. She has completed a B.Com and a PGDCA. She has been working as an accountant at Muskaan since 2019.'
            },
            {
                id: '4',
                name: 'Presanna Menon',
                role: 'Admin and Backend Support',
                image: 'presanna-menon.jpeg',
                description: 'Presanna graduated with a B.Com from Kerala University and has been working since 1970. She has been working with Muskaan since 2005. Her work involves matching books of accounts, working in tally and taxation. She enjoys her work, and is also interested in gardening, and watching and listening to classical music and dance. She likes home-made food and prefers cooking herself.'
            },
            {
                id: '5',
                name: 'Shakun Pethari',
                role: 'Admin and Backend Support',
                image: 'shakun-pethari.jpg',
                description: 'Shakun is responsible for cleaning and maintenance of Muskaan`s school building. In her free time, she enjoys embroidery. '
            },
            {
                id: '6',
                name: 'Shubham Malviya',
                role: 'Admin and Backend Support',
                image: 'shubham-malviya.jpg',
                description: 'Shubham has been working with Muskaan since 2021, and is a part of the administration and management team here. He is responsible for picking up and dropping off the day-boarding students who come to study at Jeevan Shiksha Pahal. Apart from this, he is also involved in various operational tasks at Muskaan. He has made many friends among the colleagues, students, and youth at Muskaan, and he enjoys spending time with them.  '
            },
            {
                id: '7',
                name: 'Vimla Khushwaha',
                role: 'Admin and Backend Support',
                image: 'vimla-khushwaha.jpeg',
                description: 'Vimla has been working as a cook at Muskaan since 2017. She always had a passion for cooking, but before her work here, she used to work as a labourer in other people`s fields. She loves spending time with the children here. She believes that her own children`s upbringing and education have benefited because of her working at Muskaan. Presently, two of her daughters have started college, and one daughter and son go to school.   '
            },
        ]
    },



    {
        category: 'Child Protection and Participation',
        members: [
            {
                id: '8',
                name: 'Aarti Prajapati',
                role: 'Child Protection and Participation',
                image: 'aarti-prajapati.jpg',
                description: 'Aarti lives in Kotra Sultanabad. She has been associated with Muskaan since 2012, and has been working since 2022 on issues of children`s rights and issues. She works in Mandwa, Shabri Nagar, and Bapu Nagar. She loves embroidery and meeting and interacting with people.'
            },
            {
                id: '9',
                name: 'Bharti Jat',
                role: 'Child Protection and Participation',
                image: 'bharti-jat.jpeg',
                description: 'Bharti works with the children`s group in Sargam Basti. She organises sessions with the children where they speak about the things they like, what they do not like. She conducts activities that involve playing, poems, etc. She also supports them when they are facing any problems.'
            },
            {
                id: '10',
                name: 'David Dhurve',
                role: 'Child Protection and Participation',
                image: 'david-dhurve.jpeg',
                description: 'David lives and works in Bagmugaliya. He has been working with childrens groups since November 2024. He loves playing cricket and coordinates a group to play cricket in the basti. '
            },
            {
                id: '11',
                name: 'Faiza Khan',
                role: 'Child Protection and Participation',
                image: 'faiza-khan.jpeg',
                description: 'Faiza has been working in the Azad Jugnoo Club, earlier as a child participant and now as a facilitator. She is a bundle of energy, eager to respond to different situations in her community. Through work, she is also now sure that she wants to study herself.'
            },
            {
                id: '12',
                name: 'Kavita Bisht Jhopate',
                role: 'Child Protection and Participation',
                image: 'kavita-bisht-hopate.jpeg',
                description: 'Kavita has been working in the social sector since 2008. At Muskaan, she has been involved with mentoring youth facilitators of the Azad Jugnoo Club and working on issues of child protection since 2023. She aims to create awareness on issues of violence and discrimination against children, and ensure children don`t drop out of school.'
            },
            {
                id: '13',
                name: 'Muskan Nandmehar',
                role: 'Child Protection and Participation',
                image: 'muskan-nandmehar.jpg',
                description: 'Muskan is pursuing a degree in B.Com from Bhopal, and has been working as a facilitator for the Azad Jugnoo Club since 2023. With the Club, she works on child protection and children`s rights. She is working with the Pardhi community in Navgrah Basti. She loves working with children and getting to know them, to help resolve their problems.'
            },
            {
                id: '14',
                name: 'Naaz Bee',
                role: 'Child Protection and Participation',
                image: 'naaz-bee.jpeg',
                description: 'Naaz is from Madni Nagar and has been working as a facilitator for the Azad Jugnoo Club since September 2024. In her work, she tries to listen to the children and understand their problems, helping wherever she can. She conducts fun activities with the children, such as games and poems. She herself loves travelling and meeting new people. '
            },
            {
                id: '15',
                name: 'Rashi Aswani',
                role: 'Child Protection and Participation',
                image: 'rashi-aswani.jpg',
                description: 'Rashi is a part of the Child Protection team and has been working at Muskaan since 2024. She has been working with children since 2015. '
            },
            {
                id: '16',
                name: 'Rashmi Sharma',
                role: 'Child Protection and Participation',
                image: 'rashmi-sharma.jpeg',
                description: 'Rashmi is 25 years old and has completed her B.Com. She lives in the Banjara basti in Suraj Nagar. As a facilitator for the Azad Jugnoo Club, she has been working in Barkhedi and Sewaniya since 2023. She has also started to help run the Learning Centre in Barkhedi. She likes reading books, singing, and meeting new people. She is an active member of Tatsang, a music troupe. '
            },
            {
                id: '17',
                name: 'Ruchi Srivastava',
                role: 'Child Protection and Participation',
                image: 'ruchi-shrivastava.jpeg',
                description: 'Ruchi has been working in the social sector since 2015. She works as a coordinator of the Azad Jugnoo Club in 12 settlements. Her work and the organisation, along with her fellow co-workers and children, mean a lot to her. She credits this to the family-like atmosphere at Muskaan, where she has found friendship, a sense of belonging and strength, and has learnt to fight for people`s rights. '
            },
            {
                id: '18',
                name: 'Sanjana Nimore',
                role: 'Child Protection and Participation',
                image: 'sanjana-nimore.jpeg',
                description: 'Sanjana belongs to the Mochi community, and since 2023 has been working as a facilitator for the Mochi and Kathputli communities in Rajiv Nagar. She holds sessions with children on different topics, including issues of the basti, and organises games for them too. '
            },
            {
                id: '19',
                name: 'Seema Deshmukh',
                role: 'Child Protection and Participation',
                image: 'seema-deshmukh.jpg',
                description: 'Seema has worked at Muskaan since 2004. She is responsible for various tasks, including coordinating the child protection programme, planning and assisting in the implementation of gender-related programs at the community level, conducting mental health sessions with children in the hostel and helping with individual counseling. She is interested in advocating with government departments and training people on child protection and gender-related issues. '
            },
            {
                id: '20',
                name: 'Vikas Soni',
                role: 'Child Protection and Participation',
                image: 'vikas-soni.jpeg',
                description: 'Vikas has been working with the Azad Jugnoo Club since 2024. He facilitates the clubs in Mandwa Basti and Bapu Nagar (Agariya Community). He also works with the Safe City Initiative. He presently lives in Navgrah Basti and helps his father in their cycle shop when he is not facilitating the clubs. He enjoys singing, playing, and writing poems. '
            },
            {
                id: '21',
                name: 'Zeenat Khan',
                role: 'Child Protection and Participation',
                image: 'zeenat.jpeg',
                description: 'Zeenat is in her third year of college, pursuing a Bachelor of Arts. She first became associated with Muskaan in 2024 through a fellowship and is now a facilitator for the Azad Jugnoo Club in her basti. She takes sessions with children between the ages of 4 and 16. She loves travelling. '
            },
        ]
    },

    {
        category: 'Community Strengthening',
        members: [
            {
                id: '22',
                name: 'Sanjay Vishwakarma',
                role: 'Community Strengthening',
                image: 'sanjay-community-strengthening.jpg',
                description: 'Sanjay has been working at Muskaan since 2023. His main task is to advocate for the rights and welfare of the DNT communities. He helps people from DNT communities to obtain necessary documents and benefit from government schemes, so that they are not deprived of their rights. He is also training youth to fill out forms online. '
            },
            {
                id: '23',
                name: 'Saraswati Sahu',
                role: 'Community Strengthening',
                image: 'saraswati-community-strengthening.jpg',
                description: 'Saraswati is from the Gond community and has been associated with Muskaan since the beginning. Since 2018, she has handled work related to the Shahri Mazdoor Sangathan in different capacities. She mediates in legal cases of the community and also works with the adult`s federation of the community. '
            },

        ]
    },


    {
        category: 'Education',
        members: [
            {
                id: '24',
                name: 'Anupama Sharma',
                role: 'Education',
                image: 'anupama-sharma.jpeg',
                description: 'Anupama has been teaching English to students at Muskaan since 2023. She likes to connect with children. She is passionate about reading books, writing, and continuing to learn.'
            },
            {
                id: '25',
                name: 'Brajesh Verma',
                role: 'Education',
                image: 'brajesh-verma.jpeg',
                description: 'Brajesh has been working with Muskaan since 2004. His work primarily involves children`s education and publishing. He has actively been engaged in providing an education that is helpful in children`s lives, to develop reflective and critical attitudes in children. He teaches, often using storytelling as a medium, and enjoys talking and playing with children.'
            },
            {
                id: '26',
                name: 'Dhan Kumari Thapa (Dhani)',
                role: 'Education',
                image: 'dhan-kumari -thapa.jpeg',
                description: 'Dhani has been working in the field of education since 2015. She teaches Hindi to students of classes 1 and 2. She enjoys learning and doing new things. '
            },
            {
                id: '27',
                name: 'Jyoti Mahobiya',
                role: 'Education',
                image: 'jyoti-mahobiya.jpg',
                description: 'Jyoti has been working as a teacher in Muskaan since 2023. She enjoys making new things through arts and crafts. She is pursuing her own education along with her work as a teacher. She is interested in reading books about teachers and children. '
            },

            {
                id: '28',
                name: 'Kamal Kishore Malviya',
                role: 'Education',
                image: 'kamal-kishore.jpeg',
                description: 'Kamal has been working with de-notified tribal communities at Muskaan since 2011. He engages in education through play and sports, encouraging students to respect every language, and makes an effort to combat inequality present in society. He prefers learning by observing. '
            },

            {
                id: '29',
                name: 'Kusum Mohe',
                role: 'Education',
                image: 'kusum-mohe.jpeg',
                description: 'Kusum has worked in different organisations since 2010, and has had a very good experience teaching at Muskaan. Her hobbies include playing kabaddi, badminton, reading suspense novels and entertaining and informative stories, volleyball, singing, harmonium, dholak, and theatre. She lives with her husband and two children.'
            },

            {
                id: '30',
                name: 'Megha Charmode',
                role: 'Education',
                image: 'megha-charmode.jpg',
                description: 'Megha has been working as a primary school teacher since 1992 and has been associated with Muskaan since 2010. She enjoys reading and tries to bring art into the classroom. She is also a part of the publications team of Muskaan. '
            },
            {
                id: '44',
                name: 'Nandani',
                role: 'Education',
                image: 'nandani.jpeg',
                description: 'Nandani is the warden of the girl`s hostel at Muskaan. Her work entails everything from making sure the students in the hostel wake up on time, eat their meals, exercise, and sleep on time. She has learnt a lot from the children, such as taking care of each other and respecting one another, and has developed family-like bonds with them after living in the same space for a long time. She loves writing about her experiences and one of her pieces has been published in Sahitya Akademi issue focusing on denotified tribes.'
            },
            {
                id: '40',
                name: 'Pramila Govind Gohite',
                role: 'Education',
                image: 'pramila-govind-gohite.jpg',
                description: 'Pramila is a single mother who lives with her two sons and her mother in Ayodhya Extension, Bhopal. After completing her education, she started working with an NGO dedicated to working with children. She has been teaching since 2017. She joined Muskaan in 2023, and has been teaching Mathematics and Social Science to students since 2024. Muskaan has given her a lot of space for learning. She has formed connections with the children here and is dedicated to her work. She enjoys driving and reading books in her free time.'
            },
            {
                id: '32',
                name: 'Pushplata Sangade (Lata)',
                role: 'Education',
                image: 'pushplata-sangade.jpeg',
                description: 'Lata has been teaching Hindi at Muskaan since 2020. She also conducts theatre activities with students and has worked to create many plays. '
            },
            {
                id: '41',
                name: 'Rekha Longre',
                role: 'Education',
                image: 'rekha-longre.jpg',
                description: 'Rekha was an Anganwadi and Balwadi teacher at Muskaan since 2012, and started working as a teacher at Jeevan Shiksha Pahal in 2024, where she teaches children in primary classes. She loves telling stories and poems to children, and loves old songs and dancing.'
            },
            {
                id: '39',
                name: 'Sakshi Jadhav',
                role: 'Education',
                image: 'sakshi-jadhav.jpeg',
                description: 'Sakshi joined Muskaan in 2023, and since then has been working as a teacher here. She also helps students with registering for the NIOS exams. She really enjoys working with them, and now shares an unbreakable bond with her students, which is extremely special to her. '
            },

            {
                id: '34',
                name: 'Sujata Kumbhare',
                role: 'Education',
                image: 'sujata-kumbhare.jpg',
                description: 'Sujata has been working in the education team at Muskaan since 2022. She teaches Mathematics to children and also handles their documentation.'
            },

            {
                id: '27',
                name: 'Sushma Lodhi',
                role: 'Education',
                image: 'sushma-lodhi.jpg',
                description: 'Sushma has been involved with educational practices at Muskaan since 2018. She is also responsible for overseeing child protection and other activities in 3 bastis. She is interested in teaching languages, Science, and Mathematics, and is trying to understand educational assessment in greater depth.'
            },

            {
                id: '42',
                name: 'Trisha Sangade',
                role: 'Education',
                image: 'trisha-sangade.jpeg',
                description: 'Trisha is a medical student and has completed her education from BPT. She is preparing to continue her education in the fields of MHA and MPT Orthopedic. At Muskaan, she has been teaching since 2023. In 2024, she was teaching Mathematics and English, and in 2025, she is teaching Science and Biology. '
            }

        ]
    },

 
 
    {
        category: 'Learning Centre',
        members: [
            {
                id: '45',
                name: 'Akshay Kumar Kanjar',
                role: 'Learning Centre',
                image: 'akshay-kumar-kanjar.jpg',
                description: 'Akshay lives in Karariya village in Berasia and has been associated with Muskaan since 2023. He loves teaching children and is excited to pursue his own higher education after completing his class 10th through NIOS.'
            },

            {
                id: '47',
                name: 'Inchuri Pardhi',
                role: 'Learning Centre',
                image: 'inchuri-pardhi.jpg',
                description: 'Inchuri has faced many obstacles while studying as she grew up. She persevered and has now completed her graduation with a BA in Computers. She facilitates a learning centre in her basti and works with groups to resolve issues that people are facing. She wants everyone in her community to be able to get educated and make progress. '
            },

            {
                id: '48',
                name: 'Kulsum Sheikh',
                role: 'Learning Centre',
                image: 'kulsum-sheikh.jpg',
                description: 'Kulsum lives in Jhagariya with her family and teaches in Madni Nagar, where primarily Adivasi and Muslim communities live. There are a lot of challenges in the bastis, the biggest being that when parents leave to work, they either take the children with them, or the children have to stay at home and do household work, not being able to study in either case. This is something she has been working to change. She loves teaching children through storytelling, activities, and acting out poems.  '
            },

            {
                id: '49',
                name: 'Nirmala Uikey',
                role: 'Learning Centre',
                image: 'nirmala-uikey.jpg',
                description: 'Nirmala lives in Gautam Nagar and belongs to the Gond tribe. She loves studying and through her work, she wants to make sure that all the children in her community  also study. She doesn`t want any child to be left behind, and for that, she also holds conversations with their parents so that they can dream bigger for their children and give them a good education. '
            },
            {
                id: '45',
                name: 'Ranveer Kanjar',
                role: 'Learning Centre',
                image: 'ranveer-kanjar.jpg',
                description: 'Ranveer is from Dhekpur village in Berasia town. He loves theatre and acting. He wants to bring changes to his village, such as getting everyone educated, and he would like for his community to be able to get access to more work opportunities, and opportunities to participate in sports, acting, and meetings. '
            },

            {
                id: '51',
                name: 'Sonu Sisodiya',
                role: 'Learning Centre',
                image: 'sonu-sisodiya.jpg',
                description: 'Sonu is currently in his final year of college, pursuing a Bachelor of Arts. Through his work, his goal is to help bring facilities like healthcare and education to the Pardhi community, where there is a lack of such facilities. He likes talking to people in the community, hearing about their problems, and helping them find a solution. '
            },




            {
                id: '50',
                name: 'Vikas Chauhan',
                role: 'Learning Centre',
                image: 'vikasc-hauhan.jpg',
                description: 'Vikas belongs to the Pardhi community and facilitates a center in his basti where he also helps his fellow community members with their documentation. He also participates in plays that discuss the problems faced by the community. He is completing his BA from Lal Bahadur Shastri College. He is happy when he is able to see changes that have been brought about because of their work. Now, he wants to ensure that the youth in his community have equal opportunities for education, and the right to live with dignity. In his free time, he likes reading books. '
            },

        ]
    },


    {
        category: 'Library',
        members: [

            {
                id: '60',
                name: 'Afsana',
                role: 'Library',
                image: 'afsana-library.jpeg',
                description: 'Afsana is a library facilitator in Gond Basti, Sector 3, Gandhi Nagar. She likes reading and writing, and learning about new things. '
            },
            {
                id: '59',
                name: 'Anita Nandmehar',
                role: 'Library',
                image: 'anita-namdehar.jpeg',
                description: 'Anita facilitates the library in Naya Basera and Navgrah. She enjoys travelling to new places, embroidery, and reading the newspaper daily.  '
            },
            {
                id: '58',
                name: 'Bhavna Jatav',
                role: 'Library',
                image: 'bhavna-jatav.jpeg',
                description: 'Bhavna is from Narsinghgarh and has completed class 10. She is a library facilitator at Nayi Basti, Banjara Basti, Jhagriya. She likes making friends with new people and motivating people who are not feeling good. When she has free time, she enjoys reading books based on true events and spending time with herself. '
            },
            {
                id: '57',
                name: 'Falak Roza',
                role: 'Library',
                image: 'falak-roza.jpeg',
                description: 'Falak lives in Dholak Basti in Jat Khedi. She likes sewing, travelling, and in her free time she enjoys trying new foods, reading books. She loves teaching children.'
            },
            {
                id: '54',
                name: 'Muskan Lodhi',
                role: 'Library',
                image: 'muskan-lodhi.jpeg',
                description: 'Muskan works as a library facilitator in Bagmugaliya. She really likes working with children.'
            },
          
           


            {
                id: '52',
                name: 'Murslin',
                role: 'Library',
                image: 'murslin.jpg',
                description: 'Murslin coordinates the Library Centres at Muskaan. He loves reading books and is passionate about learning new things. In his free time, he likes talking with his friends and visiting historical monuments.  '
            },
            {
                id: '56',
                name: 'Noorjahan Khan',
                role: 'Library',
                image: 'noorjehan-khan.jpeg',
                description: 'Noorjahan is a facilitator at the library centre in Sector 11, Pratap Ward in Gandhi Nagar. She is passionate about cooking in her free time and trying out new recipes. She also likes to read stories.'
            },
             
            {
                id: '55',
                name: 'Saba',
                role: 'Library',
                image: 'saba.jpeg',
                description: 'Saba set up and facilitates a library with children in Kajli Kheda Dholak Basti. In her free time, she likes to read books, learn new things, and sleep.'
            },
            {
                id: '53',
                name: 'Urmila Mewade',
                role: 'Library',
                image: 'urmila-mewade.jpeg',
                description: 'Urmila is a facilitator at the library centre in Goregaon. She enjoys working with children. '
            },     
     
         
        ]
    },


    {
        category: 'Livelihoods',
        members: [

            {
                id: '30',
                name: 'Anarkali Dhurve (Annu)',
                role: 'Livelihoods',
                image: 'anarkali-dhurve.jpeg',
                description: 'Annu has completed her M.Com and B.Ed, and has been working with Muskaan since 2023. Through the livelihood programme, she helps empower women and youth in the communities.'
            }
        ]
    },

    {
        category: 'Mental Health',
        members: [
            {
                id: '71',
                name: 'Aarti Dhanak',
                role: 'Mental Health',
                image: 'aarti_dhanak.jpg',
                description: 'Since 2022, Aarti has been working on mental health counselling at Muskaan in Rajiv Nagar, Mandwa Basti, and Naya Basera. She has learnt that the women in these communities are incredibly strong and resilient. She enjoys connecting with people, building relationships, and maintaining them. Additionally, she loves listening to music.'
            },
            {
                id: '67',
                name: 'Anita Uikey',
                role: 'Mental Health',
                image: 'anita_uikey.jpeg',
                description: 'Anita has been a counsellor among the Gond and Pardhi communities in Gandhi Nagar, Ganga Nagar, and Shyam Nagar since 2023. She loves listening to music in her free time.'
            },
              
            {
                id: '68',
                name: 'Arin Solanki',
                role: 'Mental Health',
                image: 'arin_solanki.jpg',
                description: 'Arin belongs to the Pardhi community, and has been working with the Pardhi, Ojha, Gond, and Kanjar communities in Bajri, Gautam Nagar, and Rajiv Nagar since 2024. He likes befriending new people, and dancing and acting. '
            },
            {
                id: '65',
                name: 'Chanda Uikey',
                role: 'Mental Health',
                image: 'chanda-ikey-mh.jpeg',
                description: 'Chanda has completed her graduation and works as a counsellor with the Gond and Pardhi communities. By doing this work, she feels happy that she is able to help people find some relief from their problems. Her hobby is listening to and singing songs. '
            },
            
            {
                id: '66',
                name: 'Jasveer Parmar',
                role: 'Mental Health',
                image: 'jasveer-parmar.jpeg',
                description: 'Jasveer has worked with Pardhi communities in Rajiv Nagar, Gandhi Nagar, Ehsaan Nagar, Baskhari, Banjari Basti, and Gautam Nagar since 2020. He has found a sense of brotherhood in the community, and finds his happiness in his work, in being with friends, wearing new clothes, and eating good food. He enjoys dancing and acting, and speaking in public. '
            },
            
            {
                id: '69',
                name: 'Jyoti Baghmare',
                role: 'Mental Health',
                image: 'jyoti_baghmare_mh.jpeg',
                description: 'Jyoti works with Pardhi and Gond communities in Ganga Nagar, Gandhi Nagar, Sargam, Gautam Nagar, and Baghmugalia. She likes dancing and reading books. '
            },
            {
                id: '62',
                name: 'Nasreen ',
                role: 'Mental Health',
                image: 'nasreen-mh.jpeg',
                description: 'Nasreen is a counsellor among Pardhi, Gond, Mahar, and Muslim communities in Gandhi Nagar, Rajiv Nagar, and Mandwa Sargam basti. She has been working with the communities since 2023, and loves her work. She also likes listening to music and reading poetry.'
            },
            {
                id: '64',
                name: 'Rotishna Chauhan',
                role: 'Mental Health',
                image: 'rotishna_chauhan_mh.jpg',
                description: 'Rotishna does counselling in Bans Khedi, Rajiv Nagar, Kajli Kheda, Shyam Nagar, and Banjari Basti. She has been working with Muskaan since 2024. She particularly likes the sessions she takes with children. She likes to spend her free time by herself and listen to music.  '
            },
            
            {
                id: '70',
                name: 'Sanish',
                role: 'Mental Health',
                image: 'sanish-mental-health.jpg',
                description: 'Sanish has been working with Muskaan since 2023, doing work on mental health with the Pardhi community in Rajiv Nagar, Ring Garden, and Ehsaan Nagar. She feels happy that she is able to work with her community, and wants every woman from her community to learn how to speak for herself, and to be able to read and write. '
            },
            {
                id: '70',
                name: 'Savita Sohit',
                role: 'Mental Health',
                image: 'savita-sohit.jpg',
                description: 'Savita has been working at Muskaan since 2006. She is primarily responsible for working with DNT communities. She works on the well-being of the community and is also responsible for coordinating the program team. Her aim has been to help people unite in their fight for justice. She also works with the Shahri Mazdoor Sangathan in an advisory capacity. '
            },
       
            {
                id: '63',
                name: 'Shabnam Bano',
                role: 'Mental Health',
                image: 'shabnam _ano.jpg',
                description: 'Shabnam has been working with the mental health team since 2023, in Gandhi Nagar, Ehsaan Nagar, and Ring Garden. She really enjoys her work, and she loves meeting and befriending new people. She also likes to travel and visit new places. She is from the Muslim community, and is the first woman in her family to work outside the house.  '
            },
        ]
    },


    
    {
        category: 'Research and Publications.',
        members: [
            {
                id: '30',
                name: 'Nikita Chatterjee',
                role: 'Research and Publications',
                image: 'nikita.jpg',
                description: 'Nikita has been engaging and learning with people from Adivasi communities since 2021. Presently, she is supporting young writers from DNT communities in sharing their stories through various forms. In Muskaan, she works on issues of advocacy, research and publications.'
            },
            
            {
                id: '28',
                name: 'Shivani Taneja',
                role: 'Research and Publications',
                image: 'shivani-taneja.jpeg',
                description: 'Shivani believes that education cannot be seen as an isolated academic phenomenon, and as educationists, we need to see a learner`s well-being and critical empowerment as core to an educational journey. In Muskaan, her time is spent supporting youth in their leadership journeys, bringing forth diverse children’s literature, facilitating and pushing people for deeper engagements with issues at hand. A teacher-learner at heart, she enjoys being part of classrooms and other learning spaces.'
            },
        ]
    },
];

const TeamMemberCard = ({ name, role, image, description }) => {
    const [expanded, setExpanded] = useState(false);
    const shortDescription = description.length > 150 ? description.substring(0, 150) + '...' : description;
    return (
        <div className="col-md-6">
            <div className="card shadow-sm p-3 my-1">
                <div className="d-flex align-items-center">
                    <Image style={{ width: '55px' }} src={`/assets/team/${image}`} className="rounded-2 me-3 img-fluid" alt={name} />
                    <div>
                        <h5 className="mb-0">{name}</h5>
                        <small className="text-muted">{role}</small>
                    </div>
                </div>
                <p className="mt-1 text-muted">
                    {expanded ? description : shortDescription}
                    {description.length > 150 && (
                        <span style={{ fontSize: "13px" }} className="btn btn-link p-0" onClick={() => setExpanded(!expanded)}>
                            {expanded ? 'Read Less' : 'Read More'}
                        </span>
                    )}
                </p>
            </div>
        </div>
    );
};

const OurTeam = () => {
    // Keep first collapse open by default
    const [openKeys, setOpenKeys] = useState(['0']);

    const toggleAccordion = (key) => {
        setOpenKeys((prevKeys) =>
            prevKeys.includes(key)
                ? prevKeys.filter((k) => k !== key) // Remove key if it's already open (Close it)
                : [...prevKeys, key] // Add key if it's closed (Open it)
        );
    };

    return (
        <>
            <Helmet>
                <html lang="en" />
                <title>Muskaan - Our Team</title>
                <meta name="twitter:title" content="Our Team" />
                <meta name="description" content="muskaan ngo" />
                <meta name="theme-color" content="#E6E6FA" />
            </Helmet>
            <div className="bgpettern pb-5 page-margin page-heigh">
                <Container className="pt-4">
                    <h4>Our Team</h4>
                    <p>Home / Our Team</p>
                    <Row className="with_aside-border history">
                        <Col sm={10} className='pt-3'>
                            <Accordion activeKey={openKeys} alwaysOpen>
                                {teamData.map((section, index) => (
                                    <Accordion.Item eventKey={index.toString()} key={index}>
                                        <Accordion.Header onClick={() => toggleAccordion(index.toString())}>
                                            {section.category}
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="row">
                                                {section.members.length > 0 ? (
                                                    section.members.map((member, idx) => (
                                                        <TeamMemberCard key={idx} {...member} />
                                                    ))
                                                ) : (
                                                    <p>No team members available.</p>
                                                )}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </Col>
                        <Col sm={2} className="with_aside-border-left pt-3">
                            <h4>About Us</h4>
                            <AboutSideBar />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};
export default OurTeam;